export interface Character {
  id: string;
  name: string;
  element: string;
  rarity: number;
  weapon: string;
  region: string;
  role: string;
  avatar: string;
  intro: string;
  guideId: string;
}

export const charactersList: Character[] = [
  {
    id: 'zhongli',
    name: '钟离',
    element: '岩',
    rarity: 5,
    weapon: '长柄武器',
    region: '璃月',
    role: '护盾 · 辅助',
    avatar:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20an%20elegant%20mature%20male%20with%20long%20dark%20brown%20hair%20and%20amber%20eyes%20wearing%20ornate%20black%20and%20gold%20traditional%20long%20coat%20soft%20warm%20rim%20light%20plain%20cream%20gradient%20background%20high%20detail&width=480&height=640&seq=char-zhongli&orientation=portrait',
    intro: '璃月往生堂的客卿，岩王帝君的本尊。以玉璋护盾与全元素减抗成为全队生存与增伤的核心。',
    guideId: 'guide-zhongli',
  },
  {
    id: 'hutao',
    name: '胡桃',
    element: '火',
    rarity: 5,
    weapon: '长柄武器',
    region: '璃月',
    role: '主C · 蒸发',
    avatar:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20a%20cheerful%20young%20woman%20with%20dark%20brown%20twin%20tails%20and%20red%20eyes%20wearing%20a%20black%20and%20red%20traditional%20outfit%20warm%20rim%20light%20plain%20cream%20gradient%20background%20high%20detail&width=480&height=640&seq=char-hutao&orientation=portrait',
    intro: '往生堂第七十七代堂主。以低血量换取高额攻击，是手法上限极高的火系站场主C。',
    guideId: 'guide-hutao',
  },
  {
    id: 'ganyu',
    name: '甘雨',
    element: '冰',
    rarity: 5,
    weapon: '弓',
    region: '璃月',
    role: '主C · 融化',
    avatar:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20a%20gentle%20young%20woman%20with%20light%20blue%20hair%20and%20purple%20eyes%20wearing%20a%20white%20and%20blue%20decorated%20outfit%20with%20flowers%20cool%20soft%20light%20plain%20cream%20gradient%20background&width=480&height=640&seq=char-ganyu&orientation=portrait',
    intro: '半人半仙的璃月七星秘书。霜华矢蓄力射击拥有极高倍率，是远程输出的代表角色。',
    guideId: 'guide-ganyu',
  },
  {
    id: 'raiden',
    name: '雷电将军',
    element: '雷',
    rarity: 5,
    weapon: '长柄武器',
    region: '稻妻',
    role: '副C · 充能',
    avatar:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20an%20elegant%20woman%20with%20long%20purple%20hair%20and%20violet%20eyes%20wearing%20an%20ornate%20purple%20kimono%20with%20gold%20accents%20dramatic%20soft%20light%20plain%20cream%20gradient%20background&width=480&height=640&seq=char-raiden&orientation=portrait',
    intro: '稻妻的雷电将军。梦想一心状态提供强力爆发，并为全队恢复元素能量，是循环稳定的核心。',
    guideId: 'guide-raiden',
  },
  {
    id: 'nahida',
    name: '纳西妲',
    element: '草',
    rarity: 5,
    weapon: '法器',
    region: '须弥',
    role: '辅助 · 反应',
    avatar:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20a%20small%20cute%20girl%20with%20white%20green%20hair%20and%20green%20eyes%20wearing%20a%20white%20and%20green%20dress%20with%20leaf%20motifs%20soft%20natural%20light%20plain%20cream%20gradient%20background&width=480&height=640&seq=char-nahida&orientation=portrait',
    intro: '须弥的小吉祥草王。元素战技标记敌人并协同触发草系反应，是草元素的绝对核心。',
    guideId: 'guide-nahida',
  },
  {
    id: 'kazuha',
    name: '枫原万叶',
    element: '风',
    rarity: 5,
    weapon: '单手剑',
    region: '稻妻',
    role: '辅助 · 增伤',
    avatar:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20a%20calm%20young%20man%20with%20white%20red%20hair%20and%20red%20eyes%20wearing%20a%20traditional%20red%20and%20black%20robe%20with%20a%20sword%20soft%20windy%20light%20plain%20cream%20gradient%20background&width=480&height=640&seq=char-kazuha&orientation=portrait',
    intro: '流浪的稻妻浪人武士。凭借聚怪与扩散增伤，是当前泛用性最高的辅助之一。',
    guideId: 'guide-kazuha',
  },
  {
    id: 'xiao',
    name: '魈',
    element: '风',
    rarity: 5,
    weapon: '长柄武器',
    region: '璃月',
    role: '主C · 下落攻击',
    avatar:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20a%20fierce%20young%20man%20with%20teal%20green%20hair%20and%20golden%20eyes%20wearing%20a%20dark%20green%20outfit%20with%20gold%20ornaments%20dramatic%20soft%20light%20plain%20cream%20gradient%20background&width=480&height=640&seq=char-xiao&orientation=portrait',
    intro: '守护璃月的仙众夜叉。靖妖傩舞状态下以下落攻击进行高频输出，是经典风系站场主C。',
    guideId: 'guide-xiao',
  },
  {
    id: 'neuvilette',
    name: '那维莱特',
    element: '水',
    rarity: 5,
    weapon: '法器',
    region: '枫丹',
    role: '主C · 重击',
    avatar:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20an%20elegant%20tall%20man%20with%20long%20silver%20blue%20hair%20and%20blue%20eyes%20wearing%20a%20dark%20blue%20ornate%20coat%20with%20gold%20details%20cool%20soft%20light%20plain%20cream%20gradient%20background&width=480&height=640&seq=char-neuvilette&orientation=portrait',
    intro: '枫丹最高审判官。以蓄力重击衡平推裁进行持续高额输出，是当前水系顶级主C。',
    guideId: 'guide-neuvilette',
  },
  {
    id: 'xiangling',
    name: '香菱',
    element: '火',
    rarity: 4,
    weapon: '长柄武器',
    region: '璃月',
    role: '副C · 挂火',
    avatar:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20a%20cheerful%20young%20chef%20girl%20with%20short%20brown%20hair%20and%20red%20eyes%20wearing%20an%20orange%20and%20white%20outfit%20with%20spicy%20pepper%20motifs%20warm%20light%20plain%20cream%20gradient%20background&width=480&height=640&seq=char-xiangling&orientation=portrait',
    intro: '万民堂的主厨。旋火轮提供超高后台挂火能力，是性价比极高的四星副C。',
    guideId: 'guide-xiangling',
  },
  {
    id: 'xingqiu',
    name: '行秋',
    element: '水',
    rarity: 4,
    weapon: '单手剑',
    region: '璃月',
    role: '副C · 挂水',
    avatar:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20a%20refined%20young%20man%20with%20dark%20blue%20hair%20and%20blue%20eyes%20wearing%20a%20blue%20and%20white%20scholar%20robe%20holding%20a%20sword%20soft%20light%20plain%20cream%20gradient%20background&width=480&height=640&seq=char-xingqiu&orientation=portrait',
    intro: '飞云商会的二少爷。雨帘剑提供稳定后台挂水与减伤，是蒸发与绽放体系的关键辅助。',
    guideId: 'guide-xingqiu',
  },
  {
    id: 'ayaka',
    name: '神里绫华',
    element: '冰',
    rarity: 5,
    weapon: '单手剑',
    region: '稻妻',
    role: '主C · 冻结',
    avatar:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20an%20elegant%20young%20woman%20with%20long%20white%20blue%20hair%20and%20blue%20eyes%20wearing%20a%20blue%20and%20white%20kimono%20with%20snowflake%20motifs%20cool%20soft%20light%20plain%20cream%20gradient%20background&width=480&height=640&seq=char-ayaka&orientation=portrait',
    intro: '社奉行神里家的白鹭公主。冲刺附魔配合神里流霜灭，是冻结体系中稳定高效的主C。',
    guideId: 'guide-ayaka',
  },
  {
    id: 'diluc',
    name: '迪卢克',
    element: '火',
    rarity: 5,
    weapon: '双手剑',
    region: '蒙德',
    role: '主C',
    avatar:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20a%20serious%20young%20man%20with%20red%20hair%20and%20red%20eyes%20wearing%20a%20black%20and%20red%20coat%20holding%20a%20claymore%20warm%20dramatic%20light%20plain%20cream%20gradient%20background&width=480&height=640&seq=char-diluc&orientation=portrait',
    intro: '晨曦酒庄的主人。元素爆发黎明附魔火元素，操作手感流畅，是经典火系主C。',
    guideId: 'guide-diluc',
  },
  {
    id: 'keqing',
    name: '刻晴',
    element: '雷',
    rarity: 5,
    weapon: '单手剑',
    region: '璃月',
    role: '主C',
    avatar:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20an%20elegant%20young%20woman%20with%20purple%20hair%20in%20twin%20tails%20and%20violet%20eyes%20wearing%20a%20purple%20and%20gold%20dress%20holding%20a%20sword%20soft%20light%20plain%20cream%20gradient%20background&width=480&height=640&seq=char-keqing&orientation=portrait',
    intro: '璃月七星的玉衡星。元素战技可瞬移标记，以高速普攻重击见长，操作上限较高。',
    guideId: 'guide-keqing',
  },
  {
    id: 'bennett',
    name: '班尼特',
    element: '火',
    rarity: 4,
    weapon: '单手剑',
    region: '蒙德',
    role: '辅助 · 治疗',
    avatar:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20an%20energetic%20young%20boy%20with%20blonde%20hair%20and%20green%20eyes%20wearing%20a%20green%20and%20white%20adventurer%20outfit%20holding%20a%20sword%20warm%20light%20plain%20cream%20gradient%20background&width=480&height=640&seq=char-bennett&orientation=portrait',
    intro: '蒙德冒险家协会的少年。鼓舞领域同时提供治疗与攻击力加成，被玩家称为六星火神。',
    guideId: 'guide-bennett',
  },
  {
    id: 'venti',
    name: '温迪',
    element: '风',
    rarity: 5,
    weapon: '弓',
    region: '蒙德',
    role: '辅助 · 聚怪',
    avatar:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20a%20cheerful%20young%20bard%20man%20with%20dark%20green%20braided%20hair%20and%20green%20eyes%20wearing%20a%20green%20and%20white%20outfit%20holding%20a%20lyre%20soft%20breezy%20light%20plain%20cream%20gradient%20background&width=480&height=640&seq=char-venti&orientation=portrait',
    intro: '蒙德的自由诗人。风神之诗可制造大型风场持续聚怪，是清理成群敌人的强力辅助。',
    guideId: 'guide-venti',
  },
  {
    id: 'yelan',
    name: '夜兰',
    element: '水',
    rarity: 5,
    weapon: '弓',
    region: '璃月',
    role: '副C · 挂水',
    avatar:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20an%20elegant%20woman%20with%20short%20dark%20blue%20hair%20and%20blue%20eyes%20wearing%20a%20dark%20blue%20and%20gold%20qipao%20with%20jade%20accents%20soft%20cool%20light%20plain%20cream%20gradient%20background&width=480&height=640&seq=char-yelan&orientation=portrait',
    intro: '璃月神秘的幕后情报人。元素爆发提供后台高频挂水，兼具输出与增伤能力。',
    guideId: 'guide-yelan',
  },
];